// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'
import {Field, reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import {FormGroup, InputField} from '../form'
import classnames from 'classnames'
import {changePassword} from '../../actions/user'

import {validatePassword} from '../../utils/validators'

import './index.css'

import vmxLogo from '../../media/VerimatrixLogo.png'
import ErrorIcon from '@material-ui/icons/Error'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'

class ChangePassword extends Component {

  render () {
    const {error, handleSubmit, invalid, submitSucceeded, submitFailed, submitting} = this.props
    if (!submitting && submitSucceeded && !submitFailed) {
      this.props.onHide()
    }

    return (
      <div className='change-password' onClick={e => e.stopPropagation()}>
        <form className={classnames('form change-password-form', {error})} onSubmit={handleSubmit} onMouseDown={e => e.stopPropagation()}>
          {<img src={vmxLogo} alt='Verimatrix Logo' className='vmx-logo'/>}
          <div className='change-password-fields'>
            <label className='formLabel lblChangePassword'><ExitToAppIcon/> Change your password</label>
            <div className='inputs'>
              <FormGroup labelText='Current Password'>
                <Field
                  name='password'
                  type='password'
                  component={InputField}
                />
              </FormGroup>
              <div className='password-rules'>
                <ul>
                  <li className='lh'>{'Make sure your password meets the following requirements:'}</li>
                  <li>{'Must be at least 10 characters'}</li>
                  <li>{'Contains at least 1 upper case and 1 lower case letter'}</li>
                  <li>{'Does not use any blank spaces'}</li>
                  <li>{'Has at least 1 number'}</li>
                  <li>Includes at least 1 symbol <span className='symbols'>{'(!”#$%&’()*+,-./:;<=>?@[\\]^_{|}~)'}</span></li>
                </ul>
              </div>
              <FormGroup labelText='New Password'>
                <Field
                  name='newPassword'
                  type='password'
                  component={InputField}
                />
              </FormGroup>
              <FormGroup labelText='Confirm New Password'>
                <Field
                  name='confirmNewPassword'
                  type='password'
                  component={InputField}
                />
              </FormGroup>
              <div className='error'>
                {error && <><ErrorIcon/>{` ${error}`}</>}
              </div>
            </div>
            <FormGroup>
              <div className='buttons row'>
                <div className='col-6'>
                  <button className='btn btn-accept' type='submit' disabled={invalid || submitting}>Update</button>
                </div>
                <div className='col-6'>
                  <button className='btn btn-cancel' type='cancel' onClick={this.props.onHide}>Cancel</button>
                </div>
              </div>
            </FormGroup>
          </div>
        </form>
      </div>
    )
  }
}

function onSubmit (values, dispatch) {
  values = {
    password: values.password,
    newPassword: values.newPassword
  }
  dispatch(changePassword(values))
}

export function validate (values) {
  let ret = {}
  if (!values.password || !values.password.trim()) {
    ret = {...ret, password: 'Current password cannot be blank'}
  }

  if (!values.newPassword || !values.newPassword.trim()) {
    ret = {...ret, newPassword: 'Password cannot be blank'}
  }

  if (values.newPassword && !validatePassword(values.newPassword)) {
    ret = {...ret, newPassword: 'New password does not meet requirements'}
  }

  if (!values.confirmNewPassword || !values.confirmNewPassword.trim()) {
    ret = {...ret, confirmNewPassword: 'Password cannot be blank'}
  }

  if (values.confirmNewPassword !== values.newPassword) {
    ret = {...ret, confirmNewPassword: 'Passwords should match'}
  }

  return ret
}

function mapStateToProps ({spinner}) {
  return {spinner}
}

const changePasswordRedux = connect(mapStateToProps)(ChangePassword)

export default reduxForm({
  form: 'changePassword',
  onSubmit: onSubmit,
  validate: validate
})(changePasswordRedux)
